import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const templateKindSchema = z.enum(['form', 'chat', 'survey']);

export const templateSchema = z.object({
  id: idSchema,
  workspace_id: idSchema.nullable().optional(),
  is_system: z.boolean(),
  kind: templateKindSchema,
  category: z.string().nullable().optional(),
  name: z.string(),
  description: z.string().nullable().optional(),
  thumbnail_url: z.string().url().nullable().optional(),
  config: jsonMetaSchema,
  source_template_id: idSchema.nullable().optional(),
  style_preset_id: idSchema.nullable().optional(),
  version: z.number().int().nonnegative(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type Template = z.infer<typeof templateSchema>;

export const stylePresetSchema = z.object({
  id: idSchema,
  workspace_id: idSchema.nullable().optional(),
  is_system: z.boolean(),
  name: z.string(),
  vars: z.record(z.string()),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type StylePreset = z.infer<typeof stylePresetSchema>;

export const cloneTemplateSchema = z.object({
  template_id: idSchema,
  name: z.string().min(1).max(200).optional(),
});
